import { render, staticRenderFns } from "./ProductCategoryTabs.vue?vue&type=template&id=69297a72&scoped=true&"
import script from "./ProductCategoryTabs.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryTabs.vue?vue&type=script&lang=js&"
import style0 from "./ProductCategoryTabs.vue?vue&type=style&index=0&id=69297a72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69297a72",
  null
  
)

export default component.exports